import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notificationService, type NotificationsResponse } from '@/lib/api/notificationService';

export function useNotifications(enabled = true) {
  return useQuery<NotificationsResponse>({
    queryKey: ['notifications'],
    queryFn: () => notificationService.list(),
    enabled,
  });
}

export function useMarkAllNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => notificationService.markAllRead(),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
  });
}

export function useMarkOneNotificationRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificationService.markOneRead(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
